/**
 * The breakdown dimensions the Smart Alerts Insights charts offer by default.
 *
 * One list, shared by the triggered and resolution-duration views. It was
 * duplicated in both, which is how the two came to be edited in lockstep by hand
 * every time a dimension was added.
 *
 * An org can replace this through PlatformAlertsV2.breakdownDimensions; see
 * Helper/Analytics/breakdownDimensions for how a configured block is resolved.
 * The two customer dimensions carry no label here because they take their names
 * from globalConfig.labels at render time, so renaming the customer renames them.
 */
export const SMART_ALERTS_GROUP_BY_OPTIONS = [
  { value: "originCity",    label: "By City"           },
  { value: "originState",   label: "By State"          },
  { value: "originDepot",   label: "By Depot"          },
  { value: "configName",    label: "By Project"        },
  { value: "cellChemistry", label: "By Cell Chemistry" },
  { value: "hierarchy",     label: "By Entity"         },
  { value: "fleetName",     label: "By Customer Account" },
  { value: "fleetCategory", label: "By Business Segment" },
];
